module.exports = __webpack_public_path__ + "media/images/emblems/Coppet-coat_of_arms-3f998843102820097c6fbb170aaed9b2.svg";